<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="master">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Master' : 'Master Düzenle'}} (#{{master.tipi}})</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Tür</div>
                <select *ngIf="entities" class="form-control" [(ngModel)]="master.tipi"
                        [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of entities" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="form-label">Kodu</div>
                <input type="text" class="form-control" placeholder="Kodu" [(ngModel)]="master.kodu">
              </div>
              <div class="mb-3">
                <div class="form-label">Açıklama</div>
                <input type="text" class="form-control" placeholder="Açıklama" [(ngModel)]="master.aciklama">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
